import type { Photo as PhotoT } from '../model/types';
import { paragraphs } from '../model/format';
import { adjOf, adjStyle, photoUrl } from '../lib/photos';
import { Icon } from '../components/Icon';
import type { SiteMode } from './theme';

/** Paragraphs separated by blank lines, with single line breaks kept. */
export function Paras({ text }: { text: string | undefined }) {
  return (
    <>
      {paragraphs(text).map((p, i) => (
        <p key={i}>{p.split('\n').map((line, j) => (j ? [<br key={j} />, line] : line))}</p>
      ))}
    </>
  );
}

/** An uploaded photo, framed the way the couple set it. */
export function Photo({ p, alt = '', width = 1600, lazy = false }: { p: PhotoT; alt?: string; width?: number; lazy?: boolean }) {
  return <img src={photoUrl(p, width)} alt={alt} style={adjStyle(adjOf(p))} loading={lazy ? 'lazy' : undefined} decoding="async" draggable={false} />;
}

export type EditTarget = { kind: 'header' } | { kind: 'footer' } | { kind: 'block'; id: string };

export function EditChip({ mode, label, onEdit, target }: { mode: SiteMode; label: string; onEdit?: (t: EditTarget) => void; target: EditTarget }) {
  if (mode !== 'edit' || !onEdit) return null;
  return (
    <button className="s-edit" type="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); onEdit(target); }}>
      <Icon name="pencil" size={14} />{label}
    </button>
  );
}
